import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="border-t border-acad-line bg-acad-canvas px-4 py-20 sm:py-28" data-id="element-95" data-mp="1o2vk0ww891a9">
      <motion.div initial={{
      opacity: 0,
      scale: 0.98
    }} whileInView={{
      opacity: 1,
      scale: 1
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.28,
      ease: [0.23, 1, 0.32, 1]
    }} className="relative mx-auto max-w-4xl overflow-hidden rounded-3xl border border-acad-gold/65 bg-white p-8 text-center shadow-soft sm:p-12" data-id="element-96" data-mp="222db5iwzwqms">
        <div className="absolute inset-x-0 top-0 h-1 bg-acad-gold" data-id="element-97" data-mp="1edbxnh9b2pan" />
        <span className="mx-auto inline-flex h-20 w-20 items-center justify-center rounded-full border border-acad-gold/60 bg-acad-goldSoft text-acad-goldDark" data-id="element-98" data-mp="1ec0thgby7fj0">
          <ShieldCheckIcon size={40} aria-hidden="true" data-id="element-99" data-mp="lodf4j19tl4t" />
        </span>
        <p className="mt-6 text-sm font-bold uppercase tracking-[0.16em] text-acad-gold" data-id="element-100" data-mp="p01iaak777bb">
          Complete 7-day guarantee
        </p>
        <h2 className="mt-3 font-display text-4xl font-semibold text-acad-ink sm:text-5xl" data-id="element-101" data-mp="tx1oqmkymc2y">
          Explore the Complete System Without Risk
        </h2>
        <div className="mx-auto mt-7 max-w-2xl space-y-5 text-base leading-7 text-acad-muted" data-id="element-102" data-mp="12rg1ahe3v8id">
          <p data-id="element-103" data-mp="60xcrbrv7voe">
            Open the six-volume teaching system. Explore the 150 ready-to-teach
            classes. Review the three visual handbooks. Use the bonuses. Take
            the material into one of your real classes.
          </p>
          <p className="font-semibold text-acad-ink" data-id="element-104" data-mp="ezsh0ibcmvp2">
            If you feel the material is not clear, practical, or useful for your
            teaching needs, contact us within 7 days.
          </p>
          <p className="font-display text-2xl font-semibold text-acad-gold sm:text-3xl" data-id="element-105" data-mp="1qfz6go1uz568">
            We will refund 100% of your purchase. No complicated process.
          </p>
          <p className="pt-2 text-sm" data-id="element-106" data-mp="3rhp20e7ccp9z">
            Because the purpose of Tap Dance Teacher Ready is simple: to give
            instructors material they can actually use.
          </p>
        </div>
      </motion.div>
    </section>;
}